import { useTranslation } from 'react-i18next';

export default function ProcessSection() {
  const { t } = useTranslation();

  const steps = [
    {
      step: '01',
      title: t('process.steps.0.title'),
      description: t('process.steps.0.description'),
      image: 'https://readdy.ai/api/search-image?query=Black%20African%20telecom%20engineering%20survey%20team%20with%20measuring%20equipment%20at%20construction%20site%2C%20Black%20engineers%20studying%20blueprints%20and%20inspecting%20tower%20foundation%20area%20in%20Africa%2C%20professional%20infrastructure%20planning%20and%20site%20assessment%2C%20bright%20daylight%20with%20clear%20sky%2C%20technical%20survey%20work%20photography&width=464&height=320&seq=proc-tel-01&orientation=landscape',
    },
    {
      step: '02',
      title: t('process.steps.1.title'),
      description: t('process.steps.1.description'),
      image: 'https://readdy.ai/api/search-image?query=Black%20African%20civil%20engineering%20construction%20workers%20assembling%20steel%20lattice%20tower%20and%20pouring%20reinforced%20concrete%20foundations%2C%20African%20BTP%20workers%20with%20dark%20skin%20wearing%20safety%20helmets%20and%20vests%2C%20professional%20telecom%20infrastructure%20installation%20site%20with%20crane%2C%20bright%20sunny%20day%2C%20industrial%20construction%20photography&width=464&height=320&seq=proc-btp-02&orientation=landscape',
    },
    {
      step: '03',
      title: t('process.steps.2.title'),
      description: t('process.steps.2.description'),
      image: 'https://readdy.ai/api/search-image?query=Black%20African%20telecom%20network%20testing%20and%20commissioning%20technicians%20with%20laptops%20and%20testing%20equipment%20at%20base%20station%2C%20professional%20radio%20frequency%20measurement%20and%20antenna%20alignment%20verification%20by%20dark-skinned%20engineers%2C%20bright%20daylight%20with%20organized%20technical%20setup%2C%20clean%20industrial%20environment&width=464&height=320&seq=proc-tel-03&orientation=landscape',
    },
  ];

  return (
    <section className="py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center border border-primary-300/60 rounded-full px-4 py-1.5 mb-6">
            <span className="text-primary-600 text-xs font-semibold uppercase tracking-wider">{t('process.badge')}</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold font-heading text-foreground-950 max-w-3xl mx-auto leading-tight mb-4">
            {t('process.title')}
          </h2>
          <p className="text-foreground-500 text-lg max-w-2xl mx-auto">
            {t('process.description')}
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8 animate-stagger">
          {steps.map((s) => (
            <div
              key={s.step}
              className="group bg-white rounded-3xl overflow-hidden border border-background-200/70 hover:shadow-xl transition-all duration-500"
            >
              <div className="h-48 overflow-hidden">
                <img
                  src={s.image}
                  alt={s.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="p-6">
                <div className="inline-flex items-center border border-primary-300/60 rounded-full px-3 py-1 mb-4">
                  <span className="text-primary-600 text-xs font-semibold uppercase tracking-wider">
                    {t('process.stepPrefix')} {s.step}
                  </span>
                </div>
                <h3 className="text-xl font-bold font-heading text-foreground-950 mb-3">
                  {s.title}
                </h3>
                <p className="text-foreground-500 text-sm leading-relaxed">
                  {s.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}